import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { post, patch, del } from "../../lib/request"

export const sendUserInvite = createAsyncThunk(
  'viewAccount/sendUserInvite',
  async ({ userId, email, fullName, organizationId, clientId, role }, { rejectWithValue }) => {
    try {
      
      const response = await post(`/users/${userId}/send-invite`, {
        email,
        fullName,
        organizationId,
        clientId,
        role
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



export const toggleClientStatus = createAsyncThunk(
  'viewAccount/toggleClientStatus',
  async (id, { rejectWithValue }) => {
    try {
      const response = await patch(`/clients/${id}/enable-disable`);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteClient = createAsyncThunk(
  'viewAccount/deleteClient',
  async (id, { rejectWithValue }) => {
    try {
      const response = await del(`/clients/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const viewAccountSlice = createSlice({
  name: 'viewAccount',
  initialState: {
    inviteStatus: 'idle',
    inviteError: null,
    clientStatus: 'idle',
    clientError: null,
    deleteStatus: 'idle',
    deleteError: null,
  },
  reducers: {
    resetInviteStatus: (state) => {
      state.inviteStatus = 'idle';
      state.inviteError = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendUserInvite.pending, (state) => {
        state.inviteStatus = 'loading';
        state.inviteError = null;
      })
      .addCase(sendUserInvite.fulfilled, (state) => {
        state.inviteStatus = 'succeeded';
      })
      .addCase(sendUserInvite.rejected, (state, action) => {
        state.inviteStatus = 'failed';
        state.inviteError = action.payload;
      })

      .addCase(toggleClientStatus.pending, (state) => {
        state.clientStatus = 'loading';
        state.clientError = null;
      })
      .addCase(toggleClientStatus.fulfilled, (state) => {
        state.clientStatus = 'succeeded';
      })
      .addCase(toggleClientStatus.rejected, (state, action) => {
        state.clientStatus = 'failed';
        state.clientError = action.payload;
      })
      .addCase(deleteClient.pending, (state) => {
        state.deleteStatus = 'loading';
        state.deleteError = null;
      })
      .addCase(deleteClient.fulfilled, (state) => {
        state.deleteStatus = 'succeeded';
      })
      .addCase(deleteClient.rejected, (state, action) => {
        state.deleteStatus = 'failed';
        state.deleteError = action.payload;
      });
  },
});

export const { resetInviteStatus } = viewAccountSlice.actions;
export default viewAccountSlice.reducer;